// Self-contained GeoPi brand mark + wordmark (no external assets).
export const GeoPiMark = ({ size = 28, className = "" }) => (
  <svg viewBox="0 0 40 40" width={size} height={size} className={className} aria-hidden="true">
    <defs>
      <linearGradient id="gpGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2dd4bf" />
        <stop offset="0.55" stopColor="#0e7490" />
        <stop offset="1" stopColor="#1e3a8a" />
      </linearGradient>
    </defs>
    <circle cx="20" cy="20" r="13" fill="url(#gpGrad)" />
    <path d="M20 8.5 a11.5 11.5 0 0 0 0 23" fill="none" stroke="#ffffff" strokeOpacity="0.55" strokeWidth="1.3" />
    <ellipse cx="20" cy="20" rx="18.2" ry="6.8" fill="none" stroke="url(#gpGrad)" strokeWidth="2"
      transform="rotate(-24 20 20)" />
    <circle cx="33.6" cy="11.9" r="2.7" fill="#f59e0b" />
  </svg>
);

export const GeoPiWordmark = ({ onDark = false, className = "", markSize = 26 }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <GeoPiMark size={markSize} />
    <span className={`font-display font-extrabold tracking-tight leading-none text-[17px] ${onDark ? "text-white" : "text-[#1e293b]"}`}>
      GeoP<span className="relative">ı<span className="absolute left-1/2 -translate-x-1/2 -top-[3px] h-[5px] w-[5px] rounded-full bg-amber-400" /></span>
    </span>
  </span>
);
